module.exports = __webpack_public_path__ + "static/media/2025-SWG-Uni-Student-Offer-Image.85409314.png";